<!--
 * @Description:
 * @Date: 2021-04-25 10:29:42
-->
<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="项目权限" name="projectRights">
        <el-table :data="projectRights" style="width: 100%">
          <el-table-column
            type="index"
            label="序号"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="projectName"
            label="项目名称"
          ></el-table-column>
          <el-table-column prop="projectNo" label="项目编码"></el-table-column>
          <el-table-column prop="endDt" label="执行时间"></el-table-column>
          <el-table-column
            prop="industryEnterpriseName"
            label="工业方名称"
          ></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="其它权限" name="othersRights">
        <el-table :data="othersRights" style="width: 100%">
          <el-table-column
            type="index"
            label="序号"
            width="180"
          ></el-table-column>
          <el-table-column prop="menuName" label="权限名称"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { accountManagement } from '@/api/ajax';

export default {
  props: {
    userId: {
      type: Number,
      require: true
    }
  },
  data() {
    return {
      activeName: 'projectRights',
      projectRights: [],
      othersRights: []
    };
  },
  mounted() {
    this.getRightsList();
  },
  methods: {
    handleClick() {},
    getRightsList() {
      accountManagement
        .queryLimitsOfAuthority({ type: 2, userId: this.userId })
        .then(res => {
          this.othersRights = res.pdata.otherLimitsOfAuthority;
          this.projectRights = res.pdata.projectLimitsOfAuthority;
        });
    }
  }
};
</script>

<style></style>
